import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import { IOffer } from '../../../types/offer';
import { getVillageSummaryInfo } from '../../../utils/getVillageSummaryInfo';
import { trackGoToCardKP } from '../../../utils/tracking';
import { VillageInfoLink } from '../VillageInfoLink';

import * as styles from './VillageSummary.css';

export interface IVillageSummaryProps {
  offer: IOffer;
  position: number;
}

export const VillageSummary = ({ offer, position }: IVillageSummaryProps) => {
  const { kp } = offer;

  if (!kp) {
    return null;
  }
  const { imageUrl, url, name } = kp;

  const list = getVillageSummaryInfo(kp).map(({ key, title, value }) => (
    <li key={key} className={styles['list_item']}>
      <span className={styles['list_item_heading']}>{title}</span>
      <span className={styles['list_item_text']}>{value}</span>
    </li>
  ));

  return (
    <div className={styles['container']}>
      <VillageInfoLink
        kp={kp}
        category={offer.category}
        onLinkClick={() => {
          trackGoToCardKP(offer, 'card_name_in_newlist', position);
        }}
      />
      <ul className={styles['list']}>
        <li {...mergeStyles(
          styles['list_item'],
          styles['list_item--image'],
        )}
            key="imageUrl"
        >
          <a
            href={url}
            target="_blank"
            onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
              e.stopPropagation();
              trackGoToCardKP(offer, 'card_photo_in_newlist', position);
            }}
          >
            <img
              src={imageUrl}
              alt={name}
            />
            <span className={styles['list_item_text']}>Еще фото</span>
          </a>
        </li>
        {list}
      </ul>
    </div>
  );
};
